// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';

import ContentBox from '../../ContentBox.jsx';
import Table from '../../Table.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';

type Props = {
  counselingReports: Object[],
  activePatientId: string,
  dob: string,
  match: Object,
}

class SummaryPageComponent extends Component<Props> {
  // Create action column for each row
  actionsAccessor = (row: Object) => {
    const defaultButtons = (
      <div>
        <Link to={`${this.props.match.url}/${row._id}/view`}>
          <Button>View</Button>
        </Link>
        <Link to={`${this.props.match.url}/${row._id}/edit`}>
          <PrimaryButton>Edit</PrimaryButton>
        </Link>
      </div>
    );
    return defaultButtons;
  }

  render() {
    const columns = [
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
      },
      {
        Header: 'General Topic',
        id: 'generalTopic',
      },
      {
        Header: 'Counselor Name',
        id: 'counselorName',
      },
      {
        Header: 'Topics',
        id: 'topics',
        cell: item => (item.topics ? item.topics.join(', ') : '--'),
      },
    ];

    return (
      <ContentBox title="Summary">
        <Link to={`${this.props.match.url}/add`}><PrimaryButton>Add Counseling Report</PrimaryButton></Link>
        <Table
          columns={columns}
          data={this.props.counselingReports}
          style={{}} // override max height on default Table
          extraActions={this.actionsAccessor}
        />
      </ContentBox>
    );
  }
}

const mapStateToProps = state => ({
  counselingReports: state.patient.data.counselingReports,
  activePatientId: state.patient.data.activePatientId,
  dob: state.patient.data.generalInfo.dob,
});

const SummaryPage = connect(
  mapStateToProps,
)(SummaryPageComponent);

export default SummaryPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/counseling/SummaryPage.jsx